import { Tooltip, TooltipProps } from '@smartbear/swagger-portal-component-library'
import { clsx } from 'clsx'
import { useMediaQuery } from 'usehooks-ts'

import { InfoNotificationMobile } from '~/portal/components/TooltipWrapper/InfoNotificationMobile'
import appDefaults from '~/portal/portal.defaults.json'

export type TooltipWrapperProps = TooltipProps & {
  displayOnMobile?: boolean;
}

export const TooltipWrapper = ({
  displayOnMobile = false,
  ...props
}: TooltipWrapperProps) => {
  const isMobile = useMediaQuery(appDefaults.media.mobile, { initializeWithValue: false })

  if (isMobile) {
    const {
      defaultComp,
      content,
      disabled, 
      'aria-label': ariaLabel
    } = props

    return (
      <InfoNotificationMobile
        content={content}
        defaultComp={defaultComp instanceof Function ? defaultComp({ ref: null, overflowed: false }) : defaultComp}
        visible={displayOnMobile}
        disabled={disabled}
        aria-label={ariaLabel}
      />
    )
  }

  return (
    <Tooltip {...props} className={clsx('sp-tooltip', props.className)} />
  )
}